"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jfl_1 = require("./jfl");
function map(jfd, jfl) {
    const result = jfl.groups
        .map((group) => {
        return { ...group, ...expandImplicitSOS(jfd, group) };
    })
        .map((group) => {
        return { ...group, ...setControlType(group) };
    });
    return { groups: result };
}
exports.default = map;
/**
 * Expand a the JFL if it has a single SOS, i.e.. turn this:
 * {
 *   type: 'singleFields',
 *   fields: [{field: 'SOS'}]
 * }
 *
 * into this:
 * {
 *   type: 'singleFields',
 *   fields: [
 *     {field: 'SOS', subField: 'subField1'},
 *     {field: 'SOS', subField: 'subField2'}
 *   ]
 * }
 */
function expandImplicitSOS(jfd, group) {
    if (
    // only target 'singleFields'
    group.type !== 'singleFields' ||
        // skip if there's more than one element
        group.fields.length !== 1 ||
        // only target simple fields
        !jfl_1.isSimpleField(group.fields[0])) {
        return {};
    }
    const jflField = group.fields[0];
    const [, subfieldName] = jflField.field.split('.');
    const fieldDef = jfd.getFieldDef(jflField.field);
    if (
    // skip if there are no subfields
    !fieldDef.hasSubFields() ||
        // skip if the JFL has an explicit subfield defined
        subfieldName) {
        return {};
    }
    return {
        fields: Object.keys(fieldDef.subFields.fields || {}) //
            .map((subfield) => ({
            field: `${fieldDef.name}.${subfield}`
        }))
    };
}
function setControlType(group) {
    return {
        ...group,
        fields: group.fields.map((jflDef) => {
            let control = jflDef.control;
            if (!control) {
                if (jfl_1.isFieldGroup(jflDef)) {
                    control = 'checkboxArray';
                }
                else {
                    control = 'formField';
                }
            }
            return { ...jflDef, control };
        })
    };
}
//# sourceMappingURL=jfl-mapper.js.map